/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AvailabilityType {
  BalanceAvailabilityAndFocus = "BalanceAvailabilityAndFocus",
  MaximizeAvailability = "MaximizeAvailability",
  MaximizeFocusTime = "MaximizeFocusTime",
}

export enum BookableHoursEnum {
  MeetingHours = "MeetingHours",
  WorkingHours = "WorkingHours",
}

export enum BookingLocationType {
  InDescription = "InDescription",
  Meet = "Meet",
  Zoom = "Zoom",
}

export enum EventTimeType {
  Date = "Date",
  DateTime = "DateTime",
}

export enum LinkLocationType {
  InDescription = "InDescription",
  Meet = "Meet",
  Zoom = "Zoom",
}

export enum PeriodType {
  Range = "Range",
  RollingWindow = "RollingWindow",
}

export enum PublicLinkLocationType {
  InDescription = "InDescription",
  Meet = "Meet",
  Zoom = "Zoom",
}

export enum Tag {
  Best = "Best",
  Inconvenient = "Inconvenient",
}

/**
 * A time slot
 */
export enum TimeSlot {
  T_00_00 = "T_00_00",
  T_00_30 = "T_00_30",
  T_01_00 = "T_01_00",
  T_01_30 = "T_01_30",
  T_02_00 = "T_02_00",
  T_02_30 = "T_02_30",
  T_03_00 = "T_03_00",
  T_03_30 = "T_03_30",
  T_04_00 = "T_04_00",
  T_04_30 = "T_04_30",
  T_05_00 = "T_05_00",
  T_05_30 = "T_05_30",
  T_06_00 = "T_06_00",
  T_06_30 = "T_06_30",
  T_07_00 = "T_07_00",
  T_07_30 = "T_07_30",
  T_08_00 = "T_08_00",
  T_08_30 = "T_08_30",
  T_09_00 = "T_09_00",
  T_09_30 = "T_09_30",
  T_10_00 = "T_10_00",
  T_10_30 = "T_10_30",
  T_11_00 = "T_11_00",
  T_11_30 = "T_11_30",
  T_12_00 = "T_12_00",
  T_12_30 = "T_12_30",
  T_13_00 = "T_13_00",
  T_13_30 = "T_13_30",
  T_14_00 = "T_14_00",
  T_14_30 = "T_14_30",
  T_15_00 = "T_15_00",
  T_15_30 = "T_15_30",
  T_16_00 = "T_16_00",
  T_16_30 = "T_16_30",
  T_17_00 = "T_17_00",
  T_17_30 = "T_17_30",
  T_18_00 = "T_18_00",
  T_18_30 = "T_18_30",
  T_19_00 = "T_19_00",
  T_19_30 = "T_19_30",
  T_20_00 = "T_20_00",
  T_20_30 = "T_20_30",
  T_21_00 = "T_21_00",
  T_21_30 = "T_21_30",
  T_22_00 = "T_22_00",
  T_22_30 = "T_22_30",
  T_23_00 = "T_23_00",
  T_23_30 = "T_23_30",
}

export interface CreateBookingBody {
  attendeeEmailAddress: string;
  attendeeName: string;
  eventStartMillis: any;
  notes?: string | null;
  timeZone: string;
}

export interface CreateBookingMutationInput {
  body: CreateBookingBody;
  clientMutationId?: string | null;
  dateRefetchBody?: ZonedDayTimeSlotRangeInput | null;
  linkName: string;
  slug: string;
}

export interface CreateMeetingSettingsInput {
  body?: MeetingSettingsInput | null;
  clientMutationId?: string | null;
}

export interface DayTimeSlotInput {
  date: string;
  timeSlot: TimeSlot;
}

export interface DayTimeSlotRangeInput {
  maxSlot: DayTimeSlotInput;
  minSlot: DayTimeSlotInput;
}

export interface DeleteMeetingSettingsInput {
  clientMutationId?: string | null;
  meetingSettingsId: string;
}

export interface FindOrCreateLinkNameInput {
  clientMutationId?: string | null;
}

export interface LinkTimeRangeInput {
  rangeEndTime?: string | null;
  rangeEndTimeMillis?: number | null;
  rangeStartTime?: string | null;
  rangeStartTimeMillis?: number | null;
  timeZone?: string | null;
  windowSizeDays?: number | null;
}

export interface LocationSettingsInput {
  locationDetails?: string | null;
  locationType: LinkLocationType;
}

export interface MeetingSettingsInput {
  allowFifteenMinuteMarkBooking: boolean;
  availabilityType: AvailabilityType;
  bookableHours: BookableHoursEnum;
  bookingTimeBufferHours: number;
  bookOnNoMeetingDay: boolean;
  description?: string | null;
  highlightBestTimes: boolean;
  id?: string | null;
  isActive: boolean;
  locationSettings: LocationSettingsInput;
  name: string;
  slug: string;
  timingSettings: TimingSettingsInput;
}

export interface TimingSettingsInput {
  durationMinutes: number;
  periodType: PeriodType;
  timeRange: LinkTimeRangeInput;
}

export interface UpdateMeetingSettingsInput {
  body?: MeetingSettingsInput | null;
  clientMutationId?: string | null;
}

export interface ZonedDayTimeSlotRangeInput {
  dayTimeSlotRange: DayTimeSlotRangeInput;
  timeZone?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
